import * as React from "react";
import styled from "styled-components";
import { VerticalSpacer } from "../Spacers";
import { theme } from "../../../theme";
import SmallLoadingSpinner from "../SmallLoadingSpinner";

interface Props {
  onClick?: (props?: any) => void;
  disabled?: boolean;
  title: string;
  color?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  medium?: boolean;
  iconRight?: React.ReactNode;
  fullWidth?: boolean;
  loading?: boolean;
}

const ButtonContainer = styled.button<{
  color: string;
  disabled?: boolean;
  medium?: boolean;
  fullwidth?: boolean;
}>`
  background-color: white;
  border-radius: 4px;
  padding: ${(props) => (props.medium ? "12px 16px" : "4px 16px")};
  color: ${(props) => props.color};
  font-size: ${(props) => (props.medium ? "16px" : "14px")};
  font-weight: 500;
  border: ${(props) => `1px solid ${props.color}`};
  display: flex;
  align-items: center;
  width: ${(props) => (props.fullwidth ? "100%" : "fit-content")};
  justify-content: center;
  cursor: pointer;
  height: ${(props) => (props.medium ? "36px" : "24px")};
  white-space: nowrap;

  &:disabled {
    border: none;
    background-color: ${() => theme.colors.disabled};
    color: white;
  }

  &:hover {
    filter: ${(props) => (props.disabled ? "undefined" : "opacity(0.6)")};
    box-shadow: ${(props) =>
      props.disabled ? "undefined" : "0px 4px 6px rgba(0, 0, 0, 0.1)"};
  }

  &:active {
    filter: opacity(1);
    box-shadow: none;
    background-color: ${(props) =>
      props.disabled ? "undefined" : theme.colors.primary20};
  }

  & svg > path {
    stroke: ${(props) => props.disabled ? theme.colors.white : props.color};
  }
`;

const OutlinedButton: React.FC<Props> = ({
  onClick,
  disabled,
  title,
  color = theme.colors.info,
  icon,
  type,
  medium,
  iconRight,
  fullWidth,
  loading,
}) => {
  return (
    <ButtonContainer
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      medium={medium}
      fullwidth={fullWidth}
    >
      {icon && (
        <>
          {icon} <VerticalSpacer spacing={0.5} />
        </>
      )}
      {loading ? <SmallLoadingSpinner color={color} /> : title}
      {iconRight && (
        <>
          <VerticalSpacer spacing={0.5} />
          {iconRight}
        </>
      )}
    </ButtonContainer>
  );
};

export default OutlinedButton;
